import React from 'react';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import clsx from 'clsx';

interface ComponentProps {
  filled?: boolean;
  label?: string;
  value?: string | number;
  backgroundColor?: string;
  borderColor?: string;
  highlightedValue?: boolean;
  type?: string;
  className?: string;
  dataTestId?: string;
  children?: React.ReactNode;
}

const Badge: React.FC<ComponentProps> = ({ filled = false, type, label, value, highlightedValue, backgroundColor, borderColor, className, dataTestId, children }) => {
  return (
    <div
      className={clsx(
        'inline-flex border border-solid border-content-brandMedium flex-nowrap justify-center items-center px-2 py-1 rounded gap-1 font-dm-sans text-[14px] font-medium leading-none tracking-[-0.14px]',
        borderColor && `border border-solid`,
        filled ? `bg-[${backgroundColor}]` : `bg-white`,
        type === 'LinkedExpBadge' && 'bg-[#FFEEE5]',
        className,
      )}
    >
      {label && <div className="text-content-secondary">{label}</div>}
      {isNotNullOrUndefined(value) &&
        <div className={clsx(highlightedValue && 'text-[var(--ringil3-brand-color)]')} data-testid={dataTestId}>{value}</div>}
      {children}
    </div>
  );
};

export default Badge;
